import { Field, Select } from '@fluentui/react-components';
import { useT } from '@powerportalspro/react';
import {
  AggregateDataverseChartDataSource,
  QueryAggregate,
  ChartLegendPosition,
  ChartType,
} from '@powerportalspro/react-charts';
import { DataverseChart } from '@powerportalspro/react-fluent';
import { useMemo, useState } from 'react';

// The contacts counted by age, a bar for each range of years the dropdown sets — or for each age.
// `groupByRangeSize` adds the ages up into their ranges, and every range from the youngest
// contact's to the oldest's gets a bar, so a range no contact falls in is a bar of zero rather than
// a gap. Contacts with no age are a bar of their own, (Blank); `groupByIncludeBlank: false` would
// leave them out. The chart loads again when its source changes, so the range is a dependency of
// the `useMemo` that builds it.

const STRINGS_BASE = 'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Charts.NumberRanges.NumberRangesMainDemo';

// Years a bar covers; empty for a bar for each age.
const RANGE_SIZES = ['', '5', '10', '20'];

export function NumberRangesMainSample() {
  const t = useT();
  const [rangeSize, setRangeSize] = useState('5');

  const source = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'contact',
        groupByColumn: 'ppp_age',
        groupByRangeSize: rangeSize === '' ? undefined : Number(rangeSize),
        aggregateColumn: 'contactid',
        aggregate: QueryAggregate.Count,
        singleSeriesLabel: t(`${STRINGS_BASE}.series-label`),
      }),
    [rangeSize, t],
  );

  return (
    <>
      <Field label={t(`${STRINGS_BASE}.range-size`)} orientation="horizontal">
        <Select value={rangeSize} onChange={(_, data) => setRangeSize(data.value)}>
          {RANGE_SIZES.map((size) => (
            <option key={size} value={size}>
              {size === '' ? t(`${STRINGS_BASE}.each-age`) : t(`${STRINGS_BASE}.years`, [size])}
            </option>
          ))}
        </Select>
      </Field>
      <DataverseChart
        dataSource={source}
        type={ChartType.Bar}
        title={t(`${STRINGS_BASE}.chart-title`)}
        legendPosition={ChartLegendPosition.Hidden}
        height="360px"
      />
    </>
  );
}
